/* ~~~ Entry point for the video preview page ~~~ */

import 'app/../publicPathFix.js';
// Run settings initialization ASAP
import './settings';

// Vendor imports
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { Route, Switch } from 'react-router-dom';

// Local imports
import history from 'app/state/history';
import store from 'app/state/store.js';
import RuntimeConfig from 'shared/utils/RuntimeConfig.js';
import { operations } from 'app/state/ducks/shop/index.js';
import { VideoPreviewPage } from 'app/components/LoadablePages.js';
import GlobalProviders from 'app/providers/index.js';

// Import app theme store to ensure it's initialized and sets the appropriate theme class on the root element
import 'app/state/appThemeStore';

const appConfig = RuntimeConfig.getConfig('app');

store.dispatch(
  operations.initializeApp({
    accountGUID: appConfig.account_guid,
    brandingProfile: appConfig.branding_profile,
    anonymousUserInformation: appConfig.anonymous_user_information,
    coupon: appConfig.coupon,
    homepageConfiguration: appConfig.homepage_configuration,
    premiereUpsellCouponGUID: appConfig.premiere_upsell_first_month_free_coupon_guid,
    referralCouponCode: appConfig.referral_coupon_code,
    referralCouponGUID: appConfig.referral_coupon_guid,
    selectedBusinessGUID: appConfig.selected_business_guid,
    shopStateGUID: appConfig.shop_state_guid,
    thirdPartyConfig: appConfig.third_party_config,
  }),
);

// Store the branding profile for the user who owns the video being previewed
const videoOwnerBrandingProfile = appConfig.video_owner_branding_profile;

const container = document.querySelector('[data-javascript-only-container]');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <GlobalProviders>
        <Switch>
          {/* Branded preview links are in the format `waymark.com/preview/:userVideoGUID` so
                just always show the branded version of the preview page regardless of whether
                the user video has white labeling permissions or not */}
          <Route
            path="/preview/:userVideoGUID"
            render={() => (
              <VideoPreviewPage videoOwnerBrandingProfile={videoOwnerBrandingProfile} />
            )}
          />
          {/* White-labeled preview links are in the format `video-preview.com/:userVideoGUID` so
                show the white labeled page at this path (if the user video doesn't have
                white labeling permissions, branded contents will still be displayed anyways) */}
          <Route
            path="/:userVideoGUID"
            render={() => (
              <VideoPreviewPage
                videoOwnerBrandingProfile={videoOwnerBrandingProfile}
                shouldUseWhiteLabeling
              />
            )}
          />
        </Switch>
      </GlobalProviders>
    </ConnectedRouter>
  </Provider>,
);
